<template>
  <div class="">
    <ZnBreadcrumb />
    <div
      class="main-content"
      v-title
      data-title="柜机操作记录_试剂采购库存管理系统"
    >
      <div class="search-type">
        <ul>
          <li>
            <div class="search-item">
              <span class="keywords" style="width: 45px">关键字</span>
              <!-- <img src="../../assets/images/searchIcon.png"
               alt=""> -->
              <el-tooltip content="请输入试剂名称/CAS号/试剂编号" placement="top" effect="light">
                <el-input
                    type="text"
                    v-model="alias"
                    prefix-icon="el-icon-search"
                    @keyup.enter.native="getRecord" style="width: 180px"
                />
              </el-tooltip>
            </div>
            <div class="search-item">
              <span style="width: 70px">最近操作人</span>
              <el-select
                v-model="userId"
                placeholder="请选择"
                @change="getRecord()"
                style="width: 140px"
              >
                <el-option label="全部" value=""> </el-option>
                <el-option
                  v-for="(item, index) in operationPerson"
                  :key="index"
                  :label="item.nickName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>

            <div class="search-item">
              <span style="width: 60px">执行动作</span>
              <el-select
                v-model="operation"
                placeholder="请选择"
                @change="getRecord()"
                style="width: 120px"
              >
                <el-option
                  v-for="item in operations"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="block">
              <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 300px"
                  v-model="queryTime"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </div>
            <div class="search-item" style="margin-left: 10px">
              <el-button type="primary" size="small" class="cursorPointer" @click="getRecord">
                快速查询
                <!-- 
          v-loading.fullscreen.lock="fullscreenLoading" -->
              </el-button>
            </div>
          </li>
          <!-- <li class="last">
            <el-button class="cursorPointer" @click="getRecord">
              快速查询
              
          v-loading.fullscreen.lock="fullscreenLoading"
            </el-button>
          </li> -->
        </ul>
      </div>
      <div class="goods-info">
        <el-table
          height="600px"
          :data="recordList"
          :header-cell-style="{
            background: '#F8FAFC',
            color: 'rgba(0, 0, 0, 0.85)',
            fontWeight: 700,
            height: '54px',
          }"
          border
          style="width: 100%"
        >
          <template slot="empty">
            <img src="../../assets/images/empty.png" class="empty" />
            <p>暂无操作记录</p>
          </template>
          <el-table-column prop="id" label="操作编号" width="80">
          </el-table-column>
          <el-table-column prop="code" label="试剂编号">
          </el-table-column>
          <!-- <el-table-column prop="reagentId"
                          label="试剂id">
        </el-table-column>
        <el-table-column prop="goodsNo"
                         label="商品编码">
        </el-table-column> -->
          <el-table-column prop="goodsName" label="试剂名称"> </el-table-column>
          <el-table-column prop="casNo" label="CAS号"> </el-table-column>
          <!-- <el-table-column  label="结构式">
            <template slot-scope="scope">
              <el-image :src="scope.row.structionImg?scope.row.structionImg:'https://zhinenggui.oss-cn-shanghai.aliyuncs.com/zhineng/yFecfTR4JDjikpym7GfeCNRQex4JzYYt.jpg'" alt="" style="width:50px;height:50px;" :preview-src-list="[scope.row.structionImg?scope.row.structionImg:'https://zhinenggui.oss-cn-shanghai.aliyuncs.com/zhineng/yFecfTR4JDjikpym7GfeCNRQex4JzYYt.jpg']"></el-image>
            </template>
        </el-table-column>
        <el-table-column prop="goodsWeight"
                         label="重量（单位）">
        </el-table-column>
        <el-table-column label="产品图片">
            <template slot-scope="scope">
              <el-image :src="scope.row.coverImg?scope.row.coverImg:'https://zhinenggui.oss-cn-shanghai.aliyuncs.com/zhineng/yFecfTR4JDjikpym7GfeCNRQex4JzYYt.jpg'" alt="" style="width:50px;height:50px;" :preview-src-list="[scope.row.coverImg?scope.row.coverImg:'https://zhinenggui.oss-cn-shanghai.aliyuncs.com/zhineng/yFecfTR4JDjikpym7GfeCNRQex4JzYYt.jpg']"></el-image>
            </template>
        </el-table-column>
        <el-table-column prop="size"
                         label="规格">
        </el-table-column> -->

          <el-table-column prop="cabName" label="试剂位置">
            <template slot-scope="scope">
              <span v-if="scope.row.cabCoords">{{ scope.row.cabName + "（" + scope.row.cabCoords + ")" }}</span>
              <span v-else>******</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="cabCoords"
                         label="试剂坐标">
        </el-table-column> -->
          <el-table-column prop="modifyUsername" label="最近操作人">
          </el-table-column>
          <el-table-column prop="gmtCreate" label="操作时间">
          </el-table-column>
          <el-table-column label="执行动作">
            <template slot-scope="scope">
              <span v-if="scope.row.operation == 1">入库</span>

              <span v-if="scope.row.operation == 3">预约</span>
              <span v-if="scope.row.operation == 0">申领</span>

              <span v-if="scope.row.operation == 4">取出</span>

              <span v-if="scope.row.operation == 2">归还</span>

              <span v-if="scope.row.operation == 5">发起移除</span>
              <span v-if="scope.row.operation == 6">移除</span>

              <span v-if="scope.row.operation == 7">组内转用</span>
              <span v-if="scope.row.operation == 8">组内转用</span>
              <span v-if="scope.row.operation == 9">组内转用</span>
              <span v-if="scope.row.operation == 10">组内转用</span>
              <span v-if="scope.row.operation == 12">购买绑定</span>
              <span v-if="scope.row.operation == 13">新增绑定</span>
              <span v-if="scope.row.operation == 14">修改绑定</span>
              <span v-if="scope.row.operation == 20">开启盘点</span>
              <span v-if="scope.row.operation == 21">盘点入库</span>
              <span v-if="scope.row.operation == 22">结束盘点</span>
              <span v-if="scope.row.operation == 23">确认收货</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- <Pagination
          :dataTotal="total"
          :totalpage="totalpage"
          :pagesize="searchData.pageSize"
          @changePage="changePage"
        ></Pagination> -->
        <el-pagination
          style="float: right"
          :pager-count="5"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      userId: null,
      operationPerson: [],
      orderStatus: "",
      auditStatus: "",
      alias: "",
      startTime: '',
      endTime: '',
      queryTime: [],
      code: null,
      // （1:入库，2:归还，3：借用，4:取出，5:移除，6:删除）'
      operations: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 12,
          label: "购买绑定",
        },
        {
          value: 13,
          label: "新增绑定",
        },
        {
          value: 14,
          label: "修改绑定",
        },
        {
          value: 1,
          label: "入库",
        },
        {
          value: 3,
          label: "预约",
        },
        {
          value: 0,
          label: "申领",
        },
        {
          value: 4,
          label: "取出",
        },
        {
          value: 2,
          label: "归还",
        },
        {
          value: 7,
          label: "组内转用",
        },
        {
          value: 21,
          label: "盘点入库",
        },
        {
          value: 6,
          label: "移除",
        },
        {
          value: 23,
          label: "确认收货",
        },
      ],
      id: "",
      value: "",
      num: 1,
      radio: "1",
      content: "",
      recordList: [],
      searchData: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      totalpage: 0,
      //柜机列表
      cabList: [{ value: 0, label: "全部" }],
      //选中柜机id
      cabId: 0,
      //操作
      operation: null,
    };
  },
  created() {
    this.getCabs();
    this.getRecord();
    this.getOperationUser();
  },
  methods: {
    fullscreenLoading() {},

    // 分页 size 改变
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.searchData.pageNum = this.page.currentPage;
      this.searchData.pageSize = this.page.pageSize;
      this.getRecord();
    },
    // 当前 页码 改变
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.searchData.pageNum = this.page.currentPage;
      this.searchData.pageSize = this.page.pageSize;
      this.getRecord();
    },
    // 获取操作人
    getOperationUser() {
      this.$apiFetch.get(`/lockerUser/queryUserListNoPage`).then((res) => {
        this.operationPerson = res.data;
      });
    },

    //获取柜机
    getCabs() {
      this.$apiFetch
        .get(`/lockerCabinet/queryAvailableCabList`, {
          cabName: this.searchCab,
        })
        .then((res) => {
          res.data.map((item) => {
            this.cabList.push({ value: item.id, label: item.cabName });
          });
          // this.cabList.unshift({value:0,label:'全部'})
        });
    },
    //获取记录
    getRecord() {
      this.startTime = '';
      this.endTime = '';
      if(null != this.queryTime && this.queryTime.length > 0){
        this.startTime = this.queryTime[0];
        this.endTime = this.queryTime[1];
      }
      const { alias, cabId, operation, userId,startTime,endTime } = this;
      const { pageSize, pageNum } = this.searchData;
      let params = {
        alias,
        pageSize,
        pageNum,
        cabId,
        operation,
        userId,
        startTime,
        endTime,
      };
      this.$apiFetch.get(`/lockerReagentRecord`, params).then((res) => {
        this.recordList = res.data.list;
        this.total = res.data.total;
        this.totalpage = res.data.pages;
      });
    },
    changePage(data) {
      this.searchData.pageNum = data;
      this.getRecord();
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  background-color: #ffffff;
}

/deep/ .el-table {
  //margin-top: 20px;
  border-radius: 4px 4px 0 0;
}
.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  li{
    display: flex;
    .search-item{
      display: flex;
      align-items: center;
      margin-right: var(--zng-gap);
      &:last-child{
        margin-right: 0;
      }
      span{
        display: block;
        margin-right: 10px;
      }
      .el-input{
        width: 320px;
      }
    }
  }
  // ul {
  //   li {
  //     float: left;
  //     position: relative;
  //     /deep/ .el-select {
  //       margin-right: 20px;
  //     }
  //     img {
  //       width: 14px;
  //       display: inline-block;
  //       position: relative;
  //       top: 2px;
  //       left: 23px;
  //     }
  //     input {
  //       width: 380px;
  //       height: 36px;
  //       border-radius: 4px;
  //       border: 1px solid #cccccc;
  //       padding-left: 28px;
  //     }
  //     button {
  //       width: 98px;
  //       height: 36px;
  //       background: #478aff;
  //       border-radius: 4px;
  //       font-size: 12px;
  //       color: #ffffff;
  //       margin-left: 12px;
  //     }
  //   }
  //   li.last {
  //     margin-left: 100px;
  //   }
  // }
}
.goods-info {
  padding: 20px;
  background-color: #ffffff;

  .empty {
    width: 196px;
    margin-top: 38px;
    height: unset;
  }
}
</style>
